import { Component, OnInit } from '@angular/core';
import { NgxUiLoaderService } from "ngx-ui-loader";
import { Router, ActivatedRoute } from '@angular/router';
import { startOfMonth, endOfMonth, getISOWeek, eachDayOfInterval,startOfWeek, endOfWeek, format, eachWeekOfInterval, getWeek, subWeeks, eachMonthOfInterval } from "date-fns";
import { Store, select } from '@ngrx/store';
import * as fromStore from '../../../store';
import { Subject, combineLatest } from 'rxjs';
import { takeUntil, debounceTime, filter } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { SmartPowerReportBackGroundColor, monthMap, reportTypeOption, SmartPowerReportGrade, reportType, MailRecipientType, updateInfoType, MailModuleType } from '../../../shareModel';
import * as fromFeature from '../../../my-features';
import { UpdateInfoModel } from '../../../my-features/updateInfo/update-info.model';
import { CryptoService} from '../../../services/crypto.service';
interface WeekInfo {
  id: number;
  weekNumber: number;
  startDate: Date;
  endDate: Date;
  startDateStr: string;
  endDateStr: string;
  status?: string;
  riskRate?: string;
  loadDistribution?: string;
  powerProtection?: string;
  // energySaving?: string;
}
interface MonthInfoData {
  id: number;
  month: number;
  status: string;
  riskRate: string;
  loadDistribution: string;
  powerProtection: string;
  // energySaving: string;
}

@Component({
  standalone: false,
  selector: 'app-report-list-management',
  templateUrl: './report-list-management.component.html',
  styleUrls: ['./report-list-management.component.css']
})
export class ReportListManagementComponent implements OnInit {
  private componentDestroyed = new Subject();
  private previousValue: any = null;
  UpdateInfoParam = {} as UpdateInfoModel;
  filterDate: Date = new Date();
  selectedWeek: number | null = null;
  selectedMonth: number | null = null
  weekInfoData: WeekInfo[] = [];
  IsSuperAdmin = false;
  IsAdmin = false;
  isMsp = false;
  regionId: number;
  selectRegion = null;

  weeklyData: any[] = [
  ];
  monthlyData: any[] = [
  ];

  monthInfoData = {
    id : 0,
    month: null,
    status: "",
    systemWellness: "",
    loadDistribution: "",
    powerProtection: "",
    // energySaving: "",
  };
  monthInfoArray : MonthInfoData[] = [];

  monthMap = monthMap;
  reportSettingsDialog = false;
  reportSettingDefaultTab: number;
  dialogReportSettingInput = {
    weeklyEnable: false,
    monthlyEnable: false,
    selectedWeeklyCompany: 0,
    selectedMonthlyCompany: 0,
  };
  // weeklyRecipientGroup = [];
  // weeklySelectedGroups = null;
  // monthlyRecipientGroup = [];
  // monthlySelectedGroups = null;
  recipientGroup = [];
  recipientSelectedGroups = null;
  recipientGroupDialog = false;

  dialogGroupInput = {
    id: 0,
    UpdateType: '',
    GroupName: '',
    Email: 'string',
    Type: 0 // 0(add), 1(edit)
  };

  dialogInput = {
    id: 0,
    UpdateType: '',
    Enable: 0,
    SelectedCompany: 0,
    Group: [],
  };

  groupRecipientMemberList = [];
  currentUser = '';

  lastFiveWeeksOptions: any[] = [{ label: 'Last 5 Weeks', value: 'last-5-Weeks' }];
  lastFiveWeeksValue: string = '';
  region = [];
  regionOption = [];
  module_dic = {};
  groups_dic = {};
  dialogSaveDirty = false;
  errMail = false;
  errGroupName = false;
  isUiInitialized = false;
  previousGroupIds: number[] = [];
  private isRefetching = false;
  acode = null;
  accountInfo = null;
  ReadRegionParam = {
    MspMainRegionId: 0,
    otp: ''
  };
  
  accountLoaded = true;
  proRegionLoaded = true;
  proMainRegionId = null;
  constructor(
    private ngxService: NgxUiLoaderService,
    private router: Router,
    private cryptoService: CryptoService, 
    private store: Store<fromStore.State>,
    private messageService: MessageService,
    private route: ActivatedRoute,
  ) {

    const params = this.cryptoService.aesDecrypt(this.route.snapshot.paramMap.get('hashStr'));
    if (params !== null) {
      const paramSp = params.split(',')
      if (paramSp[0] == 'AccountMgt') { //AccountManagent
        this.acode = parseInt(paramSp[1]);
        this.accountLoaded = false;
      } else { // Pro
        this.proMainRegionId = parseInt(paramSp[1]);
        this.regionId = parseInt(paramSp[2]);
        this.isMsp = true;
        this.lastFiveWeeksValue = 'last-5-Weeks';
        this.ReadRegionParam = {
          ...this.ReadRegionParam,
          MspMainRegionId: this.proMainRegionId,
        };
        this.proRegionLoaded = false;
          this.selectRegion = this.regionId
        this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
      }
    } else { 
      this.router.navigate(['dashboard']);
    }

    this.store.select(fromStore.getSingleAccountInfo(this.acode)).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res) {
        this.accountInfo = res;
          this.lastFiveWeeksValue = 'last-5-Weeks';
          this.filterDate = new Date();
        if (res.OriginCompanyId !== undefined && res.OriginCompanyId !== res.CompanyId) {
          this.isMsp = true;
          this.regionId = res.CompanyId;
          this.ReadRegionParam = {
            ...this.ReadRegionParam,
            MspMainRegionId: res.CompanyId,
          };
          this.proRegionLoaded = false;
          this.store.dispatch(new fromFeature.GetMspRegions({ ...this.ReadRegionParam }));
        } else {
          this.filterReportList();
        }
        this.accountLoaded = true;
      }
    });
    
    this.store.select(fromStore.getMspRegion).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res && res.length > 0) {
        this.region = res;

        this.regionOption = [...this.region]
          .sort((a: any, b: any) => a.Id - b.Id)
          .map(r => ({
            label: r.Region,
            value: r.Id
          }));

        if (this.selectRegion != null) {

          const isExist = this.regionOption.some(opt => opt.value == this.selectRegion);

          if (!isExist) {
            this.selectRegion = null;
          } else {
            this.selectRegion = Number(this.selectRegion);
          }
        }

        this.filterReportList();
        this.proRegionLoaded = true;
      }
    });

    this.store.select(fromStore.GetSmartPowerReportList).pipe(takeUntil(this.componentDestroyed)).subscribe(res => {
      if (res != undefined && this.accountLoaded && this.proRegionLoaded) {

        let targetDate: Date;
        if (res.length > 0) {
          const weeklylist = [];
          const monthlist = [];
          let latestTime = 0;

          res.forEach(r => {
            const currentReportTime = new Date(r.ReportDate || r.StartDate).getTime();
            if (currentReportTime > latestTime) {
              latestTime = currentReportTime;
            }

            let backGroundStatus = "";
            if (r.SystemStabilityGrade == 4 || r.LoadDistributionGrade == 4 || r.PowerQualityGrade == 4) {
              backGroundStatus = SmartPowerReportBackGroundColor[0]; // poor
            } else if (r.SystemStabilityGrade == 3 || r.LoadDistributionGrade == 3 || r.PowerQualityGrade == 3) {
              backGroundStatus = SmartPowerReportBackGroundColor[1]; // average
            } else if (r.SystemStabilityGrade == 2 || r.LoadDistributionGrade == 2 || r.PowerQualityGrade == 2) {
              backGroundStatus = SmartPowerReportBackGroundColor[2]; // good
            } else if (r.SystemStabilityGrade == 1 || r.LoadDistributionGrade == 1 || r.PowerQualityGrade == 1) {
              backGroundStatus = SmartPowerReportBackGroundColor[3]; // excellent
            }

            if (r.ReportType == reportType['Weekly']) {
              const item = {
                id: r.Id,
                week: r.Week,
                status: backGroundStatus,
                systemWellness: r.SystemStabilityGrade,
                loadDistribution: r.LoadDistributionGrade,
                powerProtection: r.PowerQualityGrade,
                // energySaving: r.EnergyConsumptionGrade,
                powerEvents: r.PowerEvents,
                riskRate: r.RiskRate,
                loadDistributionLimit: r.PeakLoadLv4Cnt + r.PeakLoadLv5Cnt + r.PeakLoadLv6Cnt,
              }
              weeklylist.push(item)
            } else {
              const month = new Date(r.ReportDate).getUTCMonth() + 1; // 取得月份
              const item = {
                id: r.Id,
                month: month,
                status: backGroundStatus,
                systemWellness: r.SystemStabilityGrade,
                loadDistribution: r.LoadDistributionGrade,
                powerProtection: r.PowerQualityGrade,
                // energySaving: r.EnergyConsumptionGrade,
                powerEvents: r.PowerEvents,
                riskRate: r.RiskRate,
                loadDistributionLimit: r.PeakLoadLv4Cnt + r.PeakLoadLv5Cnt + r.PeakLoadLv6Cnt,
              }
              monthlist.push(item)
            }
          });

          this.weeklyData = weeklylist;
          this.monthlyData = monthlist;

          const latestReportDate = latestTime > 0 ? new Date(latestTime) : this.filterDate;

          // 有資料時，依據 lastFiveWeeksValue 決定使用最新報表日期或 UI 選擇日期
          targetDate = this.lastFiveWeeksValue ? latestReportDate : this.filterDate;

        } else {
          this.weeklyData = [];
          this.monthlyData = [];
          // 如果是「選擇特定月份」，就必須維持使用者在日曆選的那個日期
          targetDate = this.lastFiveWeeksValue ? new Date() : this.filterDate;
        }


        // 把決定好的 targetDate 丟進去算 (不論有沒有資料都會執行，藉此更新/清空畫面)
        this.calculateWeekNumbers(targetDate);
        this.calculateMonthNumbers(targetDate);
      }
    });

    // Mapping Module & Groups
    combineLatest([this.store.select(fromStore.GetMailModule), this.store.select(fromStore.GetMailGroup)])
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(([moduleObj, groups]) => {

        if ((!groups || !groups.Data) && this.recipientGroup && this.recipientGroup.length > 0) {
          return;
        }
        this.module_dic = {};
        this.groups_dic = {};
        const newRecipientGroup = [];

        // 固定塞入 "寄給自己"
        newRecipientGroup.push({
          id: -1,
          GroupName: this.currentUser,
          GroupMember: ""
        });

        if (groups && groups.Data && groups.Data.length > 0) {
          groups.Data.forEach(g => {
            this.groups_dic[g.GroupId] = g;
            const membersStr = (!g.Member || g.Member.length === 0) ? '' : g.Member.map((m: any) => m.Email).join(',');

            newRecipientGroup.push({
              id: g.GroupId,
              GroupName: g.GroupName,
              GroupMember: membersStr
            });
          });
        }
        this.recipientGroup = newRecipientGroup;
        if (!this.isUiInitialized && moduleObj) {

          this.dialogReportSettingInput = {
            weeklyEnable: false, 
            monthlyEnable: false,
            selectedWeeklyCompany: 0, 
            selectedMonthlyCompany: 0,
          };
          this.recipientSelectedGroups = [];

          if (moduleObj.IsSendToMe === 1 || moduleObj.IsSendToMe === true) {
            this.recipientSelectedGroups.push(this.recipientGroup[0]);
          }

          if (moduleObj.Data && moduleObj.Data.length > 0) {
            moduleObj.Data.forEach(m => {
              if (m.ModuleSubType == reportType['Weekly']) {
                this.dialogReportSettingInput.weeklyEnable = true;
              } else if (m.ModuleSubType == reportType['Monthly']) {
                this.dialogReportSettingInput.monthlyEnable = true;
              }

              if (m.MailGroupIds && m.MailGroupIds.length > 0) {
                m.MailGroupIds.forEach(id => {
                  const target = this.recipientGroup.find(x => x.id === id);
                  if (target && !this.recipientSelectedGroups.includes(target)) {
                    this.recipientSelectedGroups.push(target);
                  }
                });
              }
            });
          }

          this.isUiInitialized = true;

        } else if (this.isUiInitialized) {
          const currentSelectedIds = this.recipientSelectedGroups.map(x => x.id);
          this.recipientSelectedGroups = this.recipientGroup.filter(x => currentSelectedIds.includes(x.id));
        }
      });
  }

  ngOnInit() {
    this.ngxService.start();
    this.UI();
    // this.lastFiveWeeksValue = this.lastFiveWeeksOptions[0].value;
    // this.getLastFiveWeeks();
    this.ngxService.stop();
  }

  getCalendarWeekClass(weekInfo: WeekInfo): string {
    return weekInfo.status || "disabled";
  }

  UI() {
    const body = document.getElementsByTagName("body")[0];
    body.classList.add("body-landing");
    body.classList.remove("body-login");
    body.classList.remove("mobile-toggle");
  }

  onMonthChange(event: any): void {
    this.filterDate = event;
    this.lastFiveWeeksValue = null;
    this.calculateWeekNumbers(this.filterDate);
    this.calculateMonthNumbers(this.filterDate);
    this.filterReportList(this.filterDate);
  }

  selectWeek(week: WeekInfo): void {
    this.selectedWeek = week.weekNumber;

    // 將數字轉成 36 進位，大幅縮短字串長度
    const weekTypeStr = '0'; // 0 代表 Weekly
    const shortId = Number(week.id).toString(36);

    // 時間戳記除以 1000 轉秒後，再轉成 36 進位
    const startTs = Math.floor(new Date(week.startDate).getTime() / 1000);
    const shortStart = startTs.toString(36);

    const endTs = Math.floor(new Date(week.endDate).getTime() / 1000);
    const shortEnd = endTs.toString(36);

    let rawParamStr = `${weekTypeStr},${shortId},${shortStart},${shortEnd}`;

    const previousHash = this.route.snapshot.paramMap.get('hashStr');
    if (previousHash) {
      try {
        // 把上一層的密文解開，它會變回類似 "AccountMgt,123" 這種簡短的明文
        const decryptedPrevious = this.cryptoService.aesDecrypt(previousHash);

        // 把目前的明文加上前一層的明文
        rawParamStr = `${rawParamStr},${decryptedPrevious}`;
      } catch (error) {
        console.error('解析原始 hashStr 失敗', error);
      }
    }

    // 全部的明文組合好後再加密
    const hashStr = this.cryptoService.aesEncrypt(rawParamStr);

    this.router.navigate(['/management/smart-power-report/report/', hashStr]);
  }

selectMonth(monthNumber: number) {
    // 從陣列中找出被點選的那個月份的資料
    const targetMonthData = this.monthInfoArray.find(m => m.month === monthNumber);

    // 如果找不到該月份資料就結束執行
    if (!targetMonthData) return; 

    // 使用找到的資料來賦值
    this.selectedMonth = targetMonthData.month;
    
    // 定義參數並壓縮 (轉成 36 進位字串)
    const monthTypeStr = '1'; // 1 代表 Monthly
    const shortId = Number(targetMonthData.id).toString(36);
    
    const year = new Date().getFullYear(); // 取得今年
    
    // 計算 Timestamp 並無條件捨去取整數，再轉成 36 進位壓縮
    const start = new Date(year, (targetMonthData.month - 1), 1, 0, 0, 0, 0); 
    const end = new Date(year, targetMonthData.month, 0, 23, 59, 59, 999); 
    
    const startTs = Math.floor(start.getTime() / 1000);
    const shortStart = startTs.toString(36);
    
    const endTs = Math.floor(end.getTime() / 1000);
    const shortEnd = endTs.toString(36);
    
    // 組合當前的短明文： "1,id,start,end"
    let rawParamStr = `${monthTypeStr},${shortId},${shortStart},${shortEnd}`;
    
    // 解密原本的 hashStr
    const previousHash = this.route.snapshot.paramMap.get('hashStr');
    if (previousHash) {
      try {
        // 解開上一層的密文，變回簡短的明文
        const decryptedPrevious = this.cryptoService.aesDecrypt(previousHash);
        
        // 將明文接在一起
        rawParamStr = `${rawParamStr},${decryptedPrevious}`;
      } catch (error) {
        console.error('解析原始 hashStr 失敗', error);
      }
    }

    // 確保全部都是乾淨的明文後再加密！
    const hashStr = this.cryptoService.aesEncrypt(rawParamStr);
    this.router.navigate(['/management/smart-power-report/report/', hashStr]);
  }

  calculateWeekNumbers(inputDate: Date): void {
    if (!inputDate) {
      this.weekInfoData = [];
      return;
    }

    let periodStart: Date;
    let periodEnd: Date;

    if (this.lastFiveWeeksValue) {
      let currentWeekStart = startOfWeek(inputDate, { weekStartsOn: 0 });
      const latestIsoWeek = getISOWeek(currentWeekStart);

      const hasLatestWeekData = this.weeklyData.some((item) => item.week === latestIsoWeek);

      if (!hasLatestWeekData) {
        currentWeekStart = subWeeks(currentWeekStart, 1);
      }

      periodStart = subWeeks(currentWeekStart, 4);
      periodEnd = endOfWeek(currentWeekStart, { weekStartsOn: 0 });
      
    } else {
      periodStart = startOfMonth(inputDate);
      periodEnd = endOfMonth(inputDate);
    }

    const weeksInterval = eachWeekOfInterval({
      start: periodStart,
      end: periodEnd
    }, { weekStartsOn: 0 });

    let rawWeekInfoData = weeksInterval.map((weekStart) => {
      const isoWeek = getISOWeek(weekStart);

      const sDate = startOfWeek(weekStart, { weekStartsOn: 0 });
      const eDate = endOfWeek(weekStart, { weekStartsOn: 0 });

      const startStr = format(sDate, 'MM/dd');
      const endStr = format(eDate, 'MM/dd');

      const weekData = this.weeklyData.find((item) => item.week === isoWeek);

      const weekInfo: WeekInfo = {
        id: 0,
        weekNumber: isoWeek,
        startDate: sDate,
        endDate: eDate,
        startDateStr: startStr,
        endDateStr: endStr,
        riskRate: "-",
        loadDistribution: "-",
        powerProtection: "-",
        // energySaving: "-",
      };

      if (weekData) {
        weekInfo.id = weekData.id;
        weekInfo.status = weekData.status; 
        weekInfo.riskRate = this.reportToScorePipe("riskRate", weekData.riskRate);
        weekInfo.loadDistribution = this.reportToScorePipe("loadDistribution", weekData.loadDistributionLimit);
        weekInfo.powerProtection = this.reportToScorePipe("powerProtection", weekData.powerEvents);
        // weekInfo.energySaving = this.reportToScorePipe("energySaving", weekData.energySaving);
      }
      return weekInfo;
    });

    if (!this.lastFiveWeeksValue) {
      const targetMonth = inputDate.getMonth();
      rawWeekInfoData = rawWeekInfoData.filter(info => info.startDate.getMonth() === targetMonth);
    }

    this.weekInfoData = rawWeekInfoData;
    this.selectedWeek = getISOWeek(inputDate);
  }

  calculateMonthNumbers(inputDate: Date): void {
    if (!inputDate) {
      this.monthInfoArray = []; // 注意：這裡需將型別改為陣列
      return;
    }

    let periodStart: Date;
    let periodEnd: Date;

    if (this.lastFiveWeeksValue) {
      let currentWeekStart = startOfWeek(inputDate, { weekStartsOn: 0 });
      const latestIsoWeek = getISOWeek(currentWeekStart);

      const hasLatestWeekData = this.weeklyData.some((item) => item.week === latestIsoWeek);

      if (!hasLatestWeekData) {
        currentWeekStart = subWeeks(currentWeekStart, 1);
      }

      periodStart = subWeeks(currentWeekStart, 4);
      periodEnd = endOfWeek(currentWeekStart, { weekStartsOn: 0 });
      
    } else {
      // 取 inputDate 該月份的所有週 (維持原樣)
      periodStart = startOfMonth(inputDate);
      periodEnd = endOfMonth(inputDate);
    }

    // 取得這個區間內涵蓋的所有月份
    const monthsInterval = eachMonthOfInterval({
      start: periodStart,
      end: periodEnd
    });

    //  把每一個月份的資料對應出來，並存成陣列
    this.monthInfoArray = monthsInterval.map(monthDate => {
      const currentMonth = monthDate.getMonth() + 1;
      const monthData = this.monthlyData.find(
        (item) => item.month === currentMonth
      );

      if (monthData) {
        return {
          id: monthData.id,
          month: currentMonth,
          status: monthData.status || "",
          riskRate: this.reportToScorePipe("riskRate", monthData.riskRate),
          loadDistribution: this.reportToScorePipe("loadDistribution", monthData.loadDistributionLimit),
          powerProtection: this.reportToScorePipe("powerProtection", monthData.powerEvents),
          // energySaving: this.reportToScorePipe("energySaving", monthData.energySaving)
        };
      } else {
        return {
          id: 0,
          month: currentMonth,
          status: "disabled",
          riskRate: "-",
          loadDistribution: "-",
          powerProtection: "-",
          // energySaving: "-"
        };
      }
    });

    this.selectedMonth = inputDate.getMonth() + 1;
  }

  reportToScorePipe(type, value) {
    if ( value === null || value === undefined || typeof value !== "number" || isNaN(value)) {
      return "-";
    }
    // const primaryValue: string = value;
    return String(value);
  }

  showReportSetting() {
    // 取得Module資訊
    const module_param = {
      otp: '',
      ModuleType: 0
    }
    this.store.dispatch(new fromFeature.GetMailModuleList(module_param));

    
    // 取得Group資訊
    const group_param = {
      otp: '',
      MailGroupIds: [] //取全部
    }
    this.store.dispatch(new fromFeature.GetMailGroupList(group_param));
    this.reportSettingsDialog = true;
  }

  onTabChange(event) {
    this.reportSettingDefaultTab = event.index;
  }

  saveRecipientSetting() {
    const dataArray = [];
    let isSendToMeChecked = false;

    if (this.dialogReportSettingInput.weeklyEnable || this.dialogReportSettingInput.monthlyEnable) {
      
      // 判斷有沒有勾選「寄給自己 (-1)」
      isSendToMeChecked = this.recipientSelectedGroups.some(g => g.id === -1);
      
      // 把正常群組的 ID 抽出來 (共用這包陣列)
      const selectedIds = this.recipientSelectedGroups.filter(g => g.id !== -1).map(g => g.id);

      //  假設 Weekly 開啟，就存入 Weekly (SubType: 0)
      if (this.dialogReportSettingInput.weeklyEnable) {
        dataArray.push({
          ModuleSubType: 0, // Weekly
          MailGroupIds: selectedIds,
          Members: []
        });
      }

      // 假設 Monthly 開啟，就存入 Monthly (SubType: 1)
      if (this.dialogReportSettingInput.monthlyEnable) {
        dataArray.push({
          ModuleSubType: 1, // Monthly
          MailGroupIds: selectedIds,
          Members: []
        });
      }
    }
    // 如果兩個開關都沒開，上面完全不會進去。
    // dataArray 會是空的 []，isSendToMeChecked 也會是 false，送出後完美清空資料庫！

    const params = {
      otp: '', 
      ModuleType: MailModuleType['SmartPowerReport'], 
      IsSendToMe: isSendToMeChecked, 
      Data: dataArray
    };

    this.store.dispatch(new fromFeature.UpdateMailModule(params)); 
    
    this.reportSettingsDialog = false;
  }

  showAddGroupDialog(period) {
    this.dialogGroupInput = {
      id: 0,
      UpdateType: 'Add Recipient Group',
      GroupName: '',
      Email: '',
      Type: 0
    };
    this.groupRecipientMemberList = [];
    this.dialogSaveDirty = false;
    this.recipientGroupDialog = true;
  }

  showEditGroupDialog(rowData) {
    this.dialogGroupInput = {
      id: rowData.id,
      UpdateType: 'Edit Recipient Group',
      GroupName: rowData.GroupName,
      Email: '',
      Type: 1
    };

    this.groupRecipientMemberList = [];
    if (this.groups_dic && this.groups_dic[rowData.id]) {
      const targetGroup = this.groups_dic[rowData.id];
      if (targetGroup && Array.isArray(targetGroup.Members)) {
        this.groupRecipientMemberList = targetGroup.Members.map((email, index) => ({
          id: index + 1,
          Email: email.Email
        }));
        
      }
    }
    this.recipientGroupDialog = true;
  }

  controlGroupMember(result: string) {
  if (result === 'addGroupMember') {
    
    const inputEmail = this.dialogGroupInput.Email;

    if (!inputEmail || inputEmail.trim() === '') {
      return; 
    }
    const emailRegex = /^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!emailRegex.test(inputEmail.trim())) {
      this.errMail = true;
      return;
    }

    // 檢查有沒有重複
    const isEmailExist = this.groupRecipientMemberList.some(
      member => member.Email === inputEmail.trim()
    );

    if (isEmailExist) {
      this.errMail = true;
      return; 
    }

    this.errMail = false;
    const maxId = this.groupRecipientMemberList.length > 0 
      ? Math.max(...this.groupRecipientMemberList.map(m => m.id)) 
      : 0;
    
    this.groupRecipientMemberList.push({ id: maxId + 1, Email: inputEmail.trim() });
    
    // 清空輸入框
    this.dialogGroupInput.Email = ''; 
  }
}

  checkGroupName() {
    const inputGroupName = this.dialogGroupInput.GroupName;
    if (!inputGroupName || inputGroupName.trim() === '') {
      return;
    }

    const currentEditId = this.dialogGroupInput.id;
    const isGroupNameExist = this.recipientGroup.some(
      g => g.GroupName === inputGroupName.trim() &&
        g.id !== -1 &&
        g.id !== currentEditId
    );

    if (isGroupNameExist) {
      this.errGroupName = true;
    } else {
      this.errGroupName = false;
    }
  }

  checkEmail() { // out focus
    const inputEmail = this.dialogGroupInput.Email;

    if (!inputEmail || inputEmail.trim() === '') {
      this.errMail = false;
      return;
    }

    const emailRegex = /^[A-Za-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/;
    if (!emailRegex.test(inputEmail.trim())) {
      this.errMail = true;
      return;
    }
    const isEmailExist = this.groupRecipientMemberList.some(
      member => member.Email === inputEmail.trim()
    );

    this.errMail = isEmailExist;
  }

  deleteGroupData(rowData, period) {
    const delete_param = {
      otp: '',
      Ids: [rowData.id]
    };

    this.store.dispatch(new fromFeature.DeleteMailGroup(delete_param));

    this.ngxService.start();
  }

  saveGroupDialog() {
    this.dialogSaveDirty = true;
    if (this.dialogGroupInput.Type === 0) {
      if (this.groupRecipientMemberList.length > 0) {
        const add_param = {
          otp : '',
          data : []
        }
        const group = {
          GroupName: this.dialogGroupInput.GroupName,
          IsChecked: false,
          Members: []
        }
        this.groupRecipientMemberList.forEach(r => {
          const member = {
            Email: r.Email,
            RecipientType: MailRecipientType['0'] // 先預設為To
          }
          group.Members.push(member)
        })
        add_param.data.push(group)
        
        this.store.dispatch(new fromFeature.AddMailGroup(add_param));
      }
    } else if (this.dialogGroupInput.Type === 1 && this.dialogGroupInput.id > 0) {
      const update_param = {
        otp: '',
        data: []
      };

      const group = {
        MailGroupId: this.dialogGroupInput.id,
        GroupName: this.dialogGroupInput.GroupName,
        Members: []
      };

      this.groupRecipientMemberList.forEach(r => {
        const member = {
          Email: r.Email,
          RecipientType: MailRecipientType['0'] // 預設為 To
        };
        group.Members.push(member);
      });

      update_param.data.push(group);
      this.store.dispatch(new fromFeature.UpdateMailGroup(update_param));
    }
    
    this.recipientGroupDialog = false;
    this.dialogSaveDirty = false;
  }

  deleteRecipientGroupMember(deleteItemIndex, rowdata) {
    if (this.groupRecipientMemberList !== undefined && this.groupRecipientMemberList.length > 0) {
      // 從 deleteItemIndex 的位置開始，刪除 1 筆資料
      this.groupRecipientMemberList.splice(deleteItemIndex, 1);
    }
  }

handleButtonClick(event: any) {
  const clickedValue = event.value;
  if (this.previousValue === clickedValue) {
    setTimeout(() => {
      this.lastFiveWeeksValue = null;
      this.previousValue = null;
      this.filterReportList(this.filterDate);
    });
  } else {
    this.previousValue = clickedValue;
    this.lastFiveWeeksValue = clickedValue;
    this.filterDate = new Date();
    this.filterReportList();
  }
}

  filterReportList(date: any = null) {
    const param = {
      otp: ""
    } as any
    if (this.isMsp) {
      if (this.selectRegion !== null) { // 第一次進來還沒選過
        param.RegionId = this.selectRegion;
      } else {
        param.RegionId = this.regionId;
      }
    }
    if (date !== null) {
      param.ReportDate = this.formateFilterDate(date);
    }
    if (this.acode !== null) {
      param.acode = this.acode
    }
    this.store.dispatch(new fromFeature.GetSmartPowerReportList(param));
  }

  formateFilterDate(date: any = null) {
    let d = new Date();
    if (date !== null) {
      d = new Date(date);
    }
    const filterDate = `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-01`; // 2026-01-01 補0
    return filterDate;
  }

  routeToProAccount () {
    this.router.navigate(['management/pro/account/']);
  }
  
  ngOnDestroy() {
    this.componentDestroyed.next(undefined);
    this.componentDestroyed.complete();
  }
}
